import { render, staticRenderFns } from "./labTestTable.vue?vue&type=template&id=468dd986&"
import script from "./labTestTable.vue?vue&type=script&lang=js&"
export * from "./labTestTable.vue?vue&type=script&lang=js&"
import style0 from "./labTestTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports